import React from 'react';
import ExecutiveSummary from '@lifeomic/phc-web-toolkit/src/components/SubjectViewer/Modules/ExecutiveSummary';
import { ModuleType } from '@lifeomic/phc-web-toolkit/src/components/SubjectViewer/Modules/basicModuleTypesConfig';
import {
  DashboardConfig,
  ModuleConfig,
} from '@lifeomic/phc-web-toolkit/src/components/LayoutConfiguration/types';
import MemberDetail from './index';

const annualReportModuleConfig: ModuleConfig<{ displayAsDuration: boolean }> = {
  version: 1,
  module: {
    key: 'member-annual-report',
    moduleType: ModuleType.AnnualReport,
    title: 'Annual Report',
    layout: {
      w: 12,
      h: 20,
      minW: 1,
      minH: 1,
      x: 0,
      y: 0,
      isResizable: true,
    },
  },
  component: { displayAsDuration: false },
};

const annualReportDashboardConfig: DashboardConfig = {
  version: 1,
  modules: [annualReportModuleConfig],
};

const annualReportInjectedPropsBase = {
  moduleKey: annualReportModuleConfig.module.key,
  isModuleVisible: true,
  dateTickFilter: { min: 0, max: 0 },
  dateTickBounds: { min: 0, max: 0 },
  dateFilter: { min: new Date(0), max: new Date() },
  isInEditMode: false,
  deviceId: 'member-detail',
  moduleConfig: annualReportModuleConfig,
  onModuleConfigChange: () => undefined,
  onDynamicDataResolved: () => ({}),
  selectedDashboardConfig: annualReportDashboardConfig,
} as const;

type AnnualReportContentProps = {
  member: fhir.Patient | null;
  memberId: string;
  fallback: React.ReactNode;
};

export const AnnualReportContent: React.FC<AnnualReportContentProps> = ({
  member,
  memberId,
  fallback,
}) => {
  if (!member) {
    return <>{fallback}</>;
  }

  return (
    <ExecutiveSummary
      {...annualReportInjectedPropsBase}
      patient={{
        ...member,
        id: member.id || memberId,
      }}
    />
  );
};

const MemberAnnualReport: React.FC = () => {
  return <MemberDetail section="annual-report" />;
};

MemberAnnualReport.displayName = 'MemberAnnualReport';
export default MemberAnnualReport;
